module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_7005.33fdaa9d.png";